/* eslint-disable react/no-children-prop */
import React from "react";
import { Wrapper } from "./styled";
import { isSelected } from "../../../../../../../../../utils/functions";
import { useSelector } from "react-redux";
import { selectedArticles } from "../../../../../../../../../store/Concept/selectors";

const Cell = ({ value, row }) => {
  const items = useSelector(selectedArticles);

  if (row.canExpand) {
    return null;
  }

  return (
    <Wrapper canExpand={row.canExpand} isSelected={isSelected(items, row.original.id)}>
      {value}
    </Wrapper>
  );
};

export default Cell;
